import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ModuleHeader from "../components/ModuleHeader";
import ReactEcharts from "echarts-for-react";
import * as echarts from "echarts";
import { REM_CONFIG } from "@/utils/fontSize";
const RevenueCompletion = ({ className = "", data, }) => {
    // 模拟数据（与示例结构对齐）
    const defaultData = [
        {
            unitName: "新疆化工",
            monthProcess: 4000,
            yearPlan: 8000,
            yearAccumulate: 9000,
        },
        {
            unitName: "包头化工",
            monthProcess: 10000,
            yearPlan: 12000,
            yearAccumulate: 15000,
        },
        {
            unitName: "榆林化工",
            monthProcess: 10000,
            yearPlan: 12000,
            yearAccumulate: 16000,
        },
        {
            unitName: "神木化工",
            monthProcess: 6000,
            yearPlan: 10000,
            yearAccumulate: 13000,
        },
    ];
    const dataSource = data || defaultData;
    const option = {
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            backgroundColor: "rgba(7, 31, 75, 0.8)",
            borderColor: "#446b9f",
            textStyle: {
                color: "#fff",
            },
        },
        legend: {
            right: "center",
            top: "4%",
            orient: "horizontal", // 显式设置水平排列
            itemGap: 4, // 调整项目间距，避免过挤
            width: "100%",
            itemHeight: 10, // 修改图标高度
            itemWidth: 10, // 修改图标宽度
            data: ["本月收入", "本年计划收入", "本年累计收入"],
            textStyle: { color: "#FFFFFF", fontSize: REM_CONFIG.fontSize.small },
        },
        grid: {
            left: "2%",
            right: "2%",
            bottom: "2%", // 保留足够底部空间放标签
            containLabel: true,
        },
        xAxis: {
            type: "category",
            data: dataSource.map((item) => item.unitName),
            axisLabel: {
                color: "#fff",
                fontSize: REM_CONFIG.fontSize.small,
                interval: 0, // 强制显示所有标签
            },
            axisLine: { lineStyle: { color: "rgba(255,255,255,0.3)" } },
            axisTick: { show: false },
        },
        yAxis: {
            type: "value",
            name: "金额（万元）",
            nameTextStyle: {
                color: "#FFFFFF",
                fontSize: REM_CONFIG.fontSize.small,
            },
            boundaryGap: [0, 0.01],
            axisLabel: { color: "#fff", fontSize: REM_CONFIG.fontSize.small },
            axisLine: { lineStyle: { color: "rgba(255,255,255,0.3)" } },
            splitLine: {
                lineStyle: { color: "rgba(255,255,255,0.1)", type: "dashed" },
            },
        },
        series: [
            // 系列1：本月收入（黄色三角形）
            {
                name: "本月收入",
                type: "pictorialBar",
                barWidth: 16,
                symbol: "triangle",
                z: 10,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#FFE082" },
                        { offset: 1, color: "#FF9800" },
                    ]),
                },
                data: dataSource.map((item) => item.monthProcess),
            },
            // 系列2：本年计划收入（青色三角形）
            {
                name: "本年计划收入",
                type: "pictorialBar",
                barWidth: 16,
                barGap: "0",
                symbol: "triangle",
                z: 10,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#B2EBF2" },
                        { offset: 1, color: "#00BCD4" },
                    ]),
                },
                data: dataSource.map((item) => item.yearPlan),
            },
            // 系列3：本年累计收入（蓝色三角形）
            {
                name: "本年累计收入",
                type: "pictorialBar",
                barWidth: 16, // 同步减小宽度
                barGap: "0", // 保持与其他系列的紧凑间距
                symbol: "triangle",
                z: 10,
                itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: "#90CAF9" },
                        { offset: 1, color: "#1976D2" },
                    ]),
                },
                data: dataSource.map((item) => item.yearAccumulate),
            },
        ],
    };
    return (_jsxs("div", { className: `
        relative 
        bg-gradient-to-t 
        from-[rgba(7,31,75,0.5)] 
        to-[rgba(6,32,66,0.2)] 
       
        flex flex-col 
        min-h-0
        ${className}
      `, children: [_jsx(ModuleHeader, { title: "\u6536\u5165\u5B8C\u6210\u60C5\u51B5" }), _jsx("div", { className: "flex-1 w-full", children: _jsx(ReactEcharts, { option: option, style: { width: "100%", height: "100%" } }) })] }));
};
export default RevenueCompletion;
